import { formatISO } from 'date-fns'
import { db } from '../store/db'
import { log } from '../common/utils'
import { Plb } from '../store/dbTypes'

export const deletePlb = async (id?: string): Promise<void> => {
  if (!id) return
  await db.plbs.update(id, {
    status: 'deleted',
    updatedAt: formatISO(new Date()),
  })
}

export const addPlb = async (plb: Plb): Promise<void> => {
  db.plbs.add(plb)
}

export const getPlb = async (plbId?: string): Promise<Plb | undefined> => {
  return plbId ? await db.plbs.get(plbId) : undefined
}

export const updatePlb = async (plb: Plb): Promise<void> => {
  const res = await db.plbs.update(plb.plbId, {
    ...plb,
    updatedAt: formatISO(new Date()),
  })
}

export const replacePlbsTable = async (newPlbs: Plb[]): Promise<void> => {
  try {
    const allPlbs = await db.plbs.toArray()
    const allPlbIds = allPlbs.map((u) => u.plbId)
    await db.plbs.bulkDelete(allPlbIds)
    await db.plbs.bulkPut(newPlbs)
  } catch (e: any) {
    log(`Error while replacing plbs table: ${e.message}`)
  }
}
